import { useQuery } from '@apollo/client';
import { QUERY_DOG_NAMES_PROFILE } from '../../graphql/dog-queries';

export default function useGetDogNamesProfile(slug) {
    const { data, loading } = useQuery(QUERY_DOG_NAMES_PROFILE, { variables: { slug } });
    return { data: data?.dogNameProfilePage, loading };
}
